import { RadioInputField } from "@/components/custom/InputField/RadioInput"
import { Separator } from "@/components/ui/separator"
import { Cron } from "./cron/cron"
import { useDispatch, useSelector } from "react-redux"
import { AppDispatch, RootState } from "@/redux"
import { workflowActions } from "@/redux/slice/workflowSlice"
import { WorkflowRunType } from "@/constants/workflows/workflowCreate"

export const WorkflowExecution = () => {
  const dispatch: AppDispatch = useDispatch()
  const { create } = useSelector((state: RootState) => state.workflow)

  return (
    <div>
      <div className="flex flex-row items-center justify-between mt-4">
        <RadioInputField
          label="On Schedule"
          value="schedule"
          descriptionLabel="Workflow is scheduled to execute automatically on a time schedule."
          isDisabled={false}
          isChecked={create.runType === WorkflowRunType.SCHEDULED}
          onChange={() => dispatch(workflowActions.setWorkflowRunType(WorkflowRunType.SCHEDULED))}
        />
        <RadioInputField
          label="Manually"
          value="manual"
          descriptionLabel="Workflow only runs when you click on the “Run Now” button manually."
          isDisabled={false}
          isChecked={create.runType === WorkflowRunType.MANUAL}
          onChange={() => dispatch(workflowActions.setWorkflowRunType(WorkflowRunType.MANUAL))}
        />
      </div>
      {create.runType === WorkflowRunType.SCHEDULED && (
        <>
          <Separator className="my-4" />
          <Cron
            onChange={(e, text) => { dispatch(workflowActions.setCron(e)); console.log(e, text) }}
            value={create.cron}
            showResultText={true}
            showResultCron={true}
          />
        </>
      )}
    </div>

  )
}
